"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponSchemaProperties = exports.CouponSchema = exports.CouponDurationSchema = exports.CouponDurationTypeEnum = exports.CouponStatusEnum = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.CouponStatusEnum = zod_1.z.enum(["active", "inactive", "deleted"]);
exports.CouponDurationTypeEnum = zod_1.z.enum(["once", "repeating", "forever"]);
exports.CouponDurationSchema = zod_1.z
    .object({
    type: exports.CouponDurationTypeEnum,
    period: zod_1.z.literal("months").optional(),
    quantity: zod_1.z.number().optional(),
})
    .refine(({ type, period, quantity }) => type === "once" || type === "forever" ? true : !!period && !!quantity, { message: "period and quantity are required if type=repeating" });
exports.CouponSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    value: zod_1.z.number(),
    unit: zod_1.z.string(),
    status: exports.CouponStatusEnum,
    duration: exports.CouponDurationSchema,
    stripe: zod_1.z.object({
        stripe_coupon_id: zod_1.z.string(),
    }),
    internal: zod_1.z.boolean(),
    promotionCode: zod_1.z.string().optional(),
    maxRedemptions: zod_1.z.number().optional(),
    expiration: zod_1.z.date().optional(),
});
exports.CouponSchemaProperties = {
    collectionName: "coupons",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=coupon-schema.js.map